import React, {Component} from "react";
import FlexView from "react-flexview";
import SimpleCheckBox from "../../../modules/SimpleCheckBox";
import SimpleButton from "../../../modules/commons/SimpleButton";

class CustomerProfileCDBHeader extends Component {
    render() {
        return (<>
            <div className="grid grid-2x gap-20px grid-mobile-none paddingTop-20px">
                <div id="grid-1">
                    <FlexView column style={{gap: 20}}>
                        <FlexView vAlignContent="center" style={{gap: 20, justifyContent: "space-between"}}>
                            <SimpleCheckBox
                                id="checkbox_name"
                                name="checkboxnama"
                                checked={this.props.dataHeader.checkboxnama}
                                onChange={({target}) =>
                                    this.props.onValueChangeCheckBox(target.name, target.checked)
                                }
                            />
                            <div className="margin-5px" style={{width: "150px"}}>
                                <div className="txt-site txt-11 txt-main txt-bold">
                                    <h4>NAMA</h4>
                                </div>
                            </div>
                            <input
                                type="text"
                                name="nama"
                                className="txt txt-sekunder-color"
                                value={this.props.dataHeader.nama ?? ""}
                                onChange={(e) =>
                                    this.props.onValueChange(e.target.name, e.target.value)
                                }
                            />
                        </FlexView>
                        <FlexView vAlignContent="center" style={{gap: 20, justifyContent: "space-between"}}>
                            <SimpleCheckBox
                                id="checkbox_nik"
                                name="checkboxnik"
                                checked={this.props.dataHeader.checkboxnik}
                                onChange={({target}) =>
                                    this.props.onValueChangeCheckBox(target.name, target.checked)
                                }
                            />
                            <div className="margin-5px" style={{width: "150px"}}>
                                <div className="txt-site txt-11 txt-main txt-bold">
                                    <h4>NIK</h4>
                                </div>
                            </div>
                            <input
                                type="text"
                                name="nik"
                                className="txt txt-sekunder-color"
                                value={this.props.dataHeader.nik ?? ""}
                                onChange={(e) => {
                                    const re = /^[^a-zA-Z\s!-\/:-@\[-`{-~]*$/;
                                    if (e.target.value === "" || re.test(e.target.value)) {
                                        this.props.onValueChange(e.target.name, e.target.value)
                                    }
                                }}
                            />
                        </FlexView>
                        <FlexView vAlignContent="center" style={{gap: 20, justifyContent: "space-between"}}>
                            <SimpleCheckBox
                                id="checkbox_phone"
                                name="checkboxnomorTeleponHP"
                                checked={this.props.dataHeader.checkboxnomorTeleponHP}
                                onChange={({target}) =>
                                    this.props.onValueChangeCheckBox(target.name, target.checked)
                                }
                            />
                            <div className="margin-5px" style={{width: "150px"}}>
                                <div className="txt-site txt-11 txt-main txt-bold">
                                    <h4>No. TELP/HP</h4>
                                </div>
                            </div>
                            <input
                                type="text"
                                name="nomorTeleponHP"
                                className="txt txt-sekunder-color"
                                value={this.props.dataHeader.nomorTeleponHP ?? ""}
                                onChange={(e) => {
                                    const re = /^[^a-zA-Z\s!-\/:-@\[-`{-~]*$/;
                                    if (e.target.value === "" || re.test(e.target.value)) {
                                        this.props.onValueChange(e.target.name, e.target.value)
                                    }
                                }}
                            />
                        </FlexView>
                    </FlexView>
                </div>
            </div>
            <div style={{textAlign: "right", marginTop: "20px", paddingTop: "20px", paddingBottom: "20px"}}>
                <FlexView hAlignContent={"right"}>
                    <SimpleButton
                        type="button"
                        text="Cari"
                        onClick={this.props.onSumbitSearch}
                    />
                    <SimpleButton
                        type="button"
                        text="Hapus"
                        onClick={this.props.onClearSearch}
                    />
                </FlexView>
            </div>
        </>)
    }
}

export default CustomerProfileCDBHeader;